
<!-- content -->
  <!-- <span *ngIf="displayAs=='unattached'" class="text-xs"><pre>{{post|json}}</pre></span>  -->
<div #content
	*ngIf="isVisible"
	class="content bg-white border-t-4 rounded-2xl border-b-[1px] border-l-[1px] border-r-[1px] border-gray-200 font-roboto"
	[ngClass]="{
		'border-t-cliking_green' : displayAs == 'post',
		'border-t-clinking_gray': displayAs == 'draft',
		'border-t-cliking_yellow': displayAs == 'planned' || displayAs=='unattached',
		'border-t-cliking_red': displayAs == 'failed',
		'h-full w-full' : !insights,
		'h-40 flex flex-col ' : insights,
		'animate-zoomInOut': post?.isNew,
		'animate-pulseFast':this.isPostsCurrentlyInSync
	}"
>
	<a
		[href]="handleCardDirection()"
		class="hover:text-black h-[7.5rem] "
		[ngClass]="{
			'cursor-not-allowed': isAnyActionInProgress()
		}"
		(click)="handleClick($event, post.id)"
	>
		<div class="text-xs  rounded-2xl gap-2 relative h-full" >
			<!-- status badge (posted, planned, draft) -->
			<div class="absolute top-0 right-0 m-2">
				<img *ngIf="displayAs == 'post'"  src="/assets/img/success.svg" alt="">
				<svg *ngIf="displayAs == 'planned'" width="26" height="27" viewBox="0 0 26 27" fill="none" ><path d="M1 13.1001C1 6.47268 6.37258 1.1001 13 1.1001C19.6274 1.1001 25 6.47268 25 13.1001C25 19.7275 19.6274 25.1001 13 25.1001C6.37258 25.1001 1 19.7275 1 13.1001Z" fill="#FFB822"></path><path  d="M13 0.600098C6.09644 0.600098 0.5 6.19654 0.5 13.1001C0.5 20.0037 6.09644 25.6001 13 25.6001C19.9036 25.6001 25.5 20.0037 25.5 13.1001C25.5 6.19654 19.9036 0.600098 13 0.600098Z" stroke="#FFB822" stroke-opacity="0.8"></path><path  d="M16 12.1001H14V8.1001C14 7.83488 13.8946 7.58053 13.7071 7.39299C13.5196 7.20545 13.2652 7.1001 13 7.1001C12.7348 7.1001 12.4804 7.20545 12.2929 7.39299C12.1054 7.58053 12 7.83488 12 8.1001V13.1001C12 13.3653 12.1054 13.6197 12.2929 13.8072C12.4804 13.9947 12.7348 14.1001 13 14.1001H16C16.2652 14.1001 16.5196 13.9947 16.7071 13.8072C16.8946 13.6197 17 13.3653 17 13.1001C17 12.8349 16.8946 12.5805 16.7071 12.393C16.5196 12.2055 16.2652 12.1001 16 12.1001ZM13 3.1001C11.0222 3.1001 9.08879 3.68659 7.4443 4.7854C5.79981 5.88422 4.51809 7.446 3.76121 9.27326C3.00433 11.1005 2.8063 13.1112 3.19215 15.051C3.578 16.9908 4.53041 18.7726 5.92894 20.1712C7.32746 21.5697 9.10929 22.5221 11.0491 22.908C12.9889 23.2938 14.9996 23.0958 16.8268 22.3389C18.6541 21.582 20.2159 20.3003 21.3147 18.6558C22.4135 17.0113 23 15.0779 23 13.1001C23 11.7869 22.7413 10.4865 22.2388 9.27326C21.7363 8.06001 20.9997 6.95762 20.0711 6.02903C19.1425 5.10044 18.0401 4.36385 16.8268 3.8613C15.6136 3.35876 14.3132 3.1001 13 3.1001ZM13 21.1001C11.4178 21.1001 9.87104 20.6309 8.55544 19.7519C7.23985 18.8728 6.21447 17.6234 5.60897 16.1616C5.00347 14.6998 4.84504 13.0912 5.15372 11.5394C5.4624 9.98753 6.22433 8.56206 7.34315 7.44324C8.46197 6.32442 9.88743 5.5625 11.4393 5.25382C12.9911 4.94513 14.5997 5.10356 16.0615 5.70906C17.5233 6.31456 18.7727 7.33994 19.6518 8.65554C20.5308 9.97113 21 11.5178 21 13.1001C21 15.2218 20.1572 17.2567 18.6569 18.757C17.1566 20.2572 15.1217 21.1001 13 21.1001Z" fill="white"></path></svg>

				<svg *ngIf="displayAs == 'unattached'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FD397A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link2-off-icon lucide-link-2-off"><path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/></svg>
				<svg  *ngIf="displayAs == 'draft'" width="29" height="28" viewBox="0 0 29 28" fill="none" >
					<path d="M1.94141 14C1.94141 6.8203 7.7617 1 14.9414 1C22.1211 1 27.9414 6.8203 27.9414 14C27.9414 21.1797 22.1211 27 14.9414 27C7.7617 27 1.94141 21.1797 1.94141 14Z" fill="#8693A6"/>
					<path d="M14.9414 0.5C7.48556 0.5 1.44141 6.54416 1.44141 14C1.44141 21.4558 7.48556 27.5 14.9414 27.5C22.3972 27.5 28.4414 21.4558 28.4414 14C28.4414 6.54416 22.3972 0.5 14.9414 0.5Z" stroke="#8693A6" stroke-opacity="0.403922"/>
					<circle cx="14.9414" cy="14" r="9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 4"/>
				</svg>
				<svg *ngIf="displayAs == 'failed'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FD397A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert-icon lucide-triangle-alert"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
			</div>
			<div
				[ngClass]="{ 'whitening-filter': isAnyActionInProgress() }"
				class="relative h-full"
			>
				<div class="grid grid-cols-3 h-full">
					<!-- post images gallery-->
					<div class="p-2 h-[7rem]" *ngIf="mainMedia && postImagesCount > 1">
						<div class="relative w-full h-full ml-2 mt-2 p-2">
							<!-- Base layer with gradient -->  <!-- Second layer with gradient -->
							<div class="absolute -top-2 -left-2 bg-gradient-to-b from-blue-900 to-blue-700 w-[100px] h-[90px]"></div>
							<!-- Third layer with gradient -->
							<div class="absolute -top-1 -left-1 bg-gradient-to-b from-teal-700 to-teal-600 w-[100px] h-[90px]"></div>
							<!-- Top layer with gradient -->
							<div class="absolute top-0 left-0  w-[100px] h-[90px]">
								<div>
									<img *ngIf="mediaIsVideo(mainMedia)" controls src="assets/img/video-icon.png" >
									<img *ngIf="!mediaIsVideo(mainMedia)" [src]="mainMedia.url" class="w-auto m-auto" style="width:100px; height:90px;"/>
									<div *ngIf="postImagesCount>1" class="absolute top-0 right-1 rounded-full border-[2px] font-semibold border-cliking_blue bg-white text-xs text-cliking_blue w-7 h-7 text-center p-1" style="transform: translate(50%, -50%);" >+{{postImagesCount-1}}</div>
								</div>
							</div>
						</div>
					</div>


					<div *ngIf="mainMedia && postImagesCount <= 1" class="relative " [ngClass]="{'m-0 p-0 block rounded-tl-2xl': mainMedia !== null}">
						<img *ngIf="mediaIsVideo(mainMedia)" controls src="assets/img/video-icon.png" class="rounded-tl-2xl h-28" />
						<img *ngIf="!mediaIsVideo(mainMedia)" [src]="mainMedia.url" class="w-full rounded-tl-2xl object-cover h-[7.5rem]" referrerpolicy="no-referrer" [ngClass]="{
							'rounded-tl-2xl': insights,
							'rounded-l-2xl': !insights,
							}"/>
					</div>

					<!--   -->
					<div class="flex flex-col justify-between h-full p-2"
						[ngClass]="{
							'col-span-2': mainMedia,
							'pl-1': mainMedia && postImagesCount <= 1,
							'pl-2': mainMedia && postImagesCount > 1,
							'col-span-3': mainMedia === null,
						}"
					>
						<span class="flex w-full">
							<span class="flex flex-col w-full truncate">
								<!-- target group -->
								<span class="truncate-text truncate ml-2 w-[82.5%]" (mouseenter)="isGroupNamesToolTip=true" (mouseleave)="isGroupNamesToolTip=false">
									{{ "generic.on" | translate }} {{ getPostGroupsNamesList() }}
								</span>
								<span *ngIf="isGroupNamesToolTip && (activeGroups.length> 1|| isTruncated)" class="absolute shadow-sm text-xs z-50  top-5 text-slate-600  px-2 py-1 border-2 bg-white rounded-lg max-h-80 overflow-auto">
									<ul>
										<li *ngFor="let item of activeGroups">- {{item}}</li>
									</ul>
								</span>
								<!-- title -->
								<span class="font-semibold text-sm ml-2 truncate overflow-hidden whitespace-nowrap max-w-full mr-6">
									{{ post.title }}
								</span>
						</span>
					</span>
					<!-- post text -->
					<div class="flex flex-col relative z-10">
						<p class="pannel-trigger w-full break-words ml-2 min-h-[35px] pr-2">
							{{
								post.text.length > 55
								? post.text.substring(0, 55) + "..."
								: post.text
							}}
						</p>
						<span *ngIf="showDateToolTip" class="absolute shadow-sm text-xs z-50 top-1 text-slate-600 text-center px-2 py-1 border-2 bg-white rounded-lg">
							{{postToolTipDatePrefix()|translate}} {{post | extractPostTimeStamp:displayAs |timeStampToHumanReadable}}
						</span>

						<!-- <span *ngIf="post.id==21160" class=" m-0 text-[8px] text-red-600">
							{{currentPlaTformsFilters|json}}
							<br>
							{{postUniquePlatforms|json}}
						</span> -->
						<p
							*ngIf="!ftIsCreationInProgress()"
							class="ml-2 text-[9px] flex"
							[ngClass]="{
								'mt-1': mainMedia,
								'mt-4': !mainMedia,
							}"
							(mouseenter)="showDateToolTip=true"
							(mouseleave)="showDateToolTip=false"
						>
							{{post | extractPostTimeStamp:displayAs | passedTime:displayAs | translate }}

								<span class="ml-[3px]" *ngFor="let platform of postUniquePlatforms">
									<span *ngIf="!dashboard">
										<app-social-media-round-icon [source]="platform" [greyedOut]="homePage? null :!platformFilterMapping[platform]"></app-social-media-round-icon>
									</span>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a>

	<hr *ngIf="insights"/>
	<!-- post deletion || creation message -->
	<div
		*ngIf="isAnyActionInProgress()"
		class="flex justify-start items-center p-2 gap-1 space-x-4 w-full h-10 relative"
		(mouseenter)="user.isAdmin ? isHoveredAdmin = true : null"
		(mouseleave)="isHoveredAdmin = false"
	>
		<span *ngIf="ftIsDeletionInProgress()" class="text-cliking_red">
			<svg  width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
		</span>
		<span class="text-sm">{{ getPostStatusKey() | translate }}</span>
		<!-- bouncing dots -->
		<div class="flex justify-center items-center space-x-1">
			<div class="w-1 h-1 rounded-full bg-gray-400 animate-dot1"></div>
			<div class="w-1 h-1 rounded-full bg-gray-400 animate-dot2"></div>
			<div class="w-1 h-1 rounded-full bg-gray-400 animate-dot3"></div>

			<!-- <div class="w-1 h-1 origin-top-left rotate-180 bg-[#2d2d2d] rounded-full"></div>
			<div class="w-1 h-1 origin-top-left rotate-180 bg-[#d9d9d9] rounded-full"></div>
			<div class="w-1 h-1 origin-top-left rotate-180 bg-[#d9d9d9] rounded-full"></div> -->
			<!-- </div> -->
		</div>
		<div
			*ngIf="user.isAdmin && isHoveredAdmin"
			class="absolute right-0 cursor-pointer"
			(click)="changePostStatus()"
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
			</svg>
		</div>
	</div>
	<!-- Insights -->
	<ul *ngIf="!isAnyActionInProgress() && insights" class="flex text-xs justify-evenly space-x-4 w-full h-10" [ngClass]="{'text-gray-200':!notOnlyOnGoogle()||displayAs != 'post'}">
		<li class="flex items-center space-x-2">
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye">
				<path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
				<circle cx="12" cy="12" r="3" />
			</svg>
			<span>{{ displayAs == 'post' && notOnlyOnGoogle() ? (post.views|kMNotation) : '--' }}</span>
		</li>
		<li class="flex items-center space-x-2">
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-thumbs-up"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/></svg>
			<span>{{ displayAs == 'post' && notOnlyOnGoogle()  ? (post.reactions|kMNotation) : '--'  }}</span>
		</li>
		<li class="flex items-center space-x-2">
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle-more"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>
			<span>{{ displayAs == 'post' && notOnlyOnGoogle()  ? (post.comments|kMNotation) : '--' }}</span>
		</li>
		<li class="flex items-center space-x-2">
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share-2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>
			<span>{{ displayAs == 'post' && notOnlyOnGoogle()  ? (post.shares|kMNotation) : '--' }}</span>
		</li>

		<!-- Dropdown Menu -->
		<li class="flex items-center space-x-2 z-20 text-gray-600">
			<div class="dropdown dropdown-end ">
				<div #dropdownTrigger tabindex="0" role="button" class="hover:bg-slate-200 rounded-md p-1">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sliders-vertical"> <line x1="4" x2="4" y1="21" y2="14" /> <line x1="4" x2="4" y1="10" y2="3" /> <line x1="12" x2="12" y1="21" y2="12" /> <line x1="12" x2="12" y1="8" y2="3" /> <line x1="20" x2="20" y1="21" y2="16" /> <line x1="20" x2="20" y1="12" y2="3" /> <line x1="2" x2="6" y1="14" y2="14" /> <line x1="10" x2="14" y1="8" y2="8" /> <line x1="18" x2="22" y1="16" y2="16" />
					</svg>
				</div>
				<ul *ngIf="!isPostsCurrentlyInSync" #dropdownContent tabindex="0" class="dropdown-content menu bg-base-100 rounded-box border z-[1] w-52 p-2 shadow text-xs" [ngClass]="{
					'text-cliking_green':displayAs=='post',
					'text-cliking_yellow':displayAs=='planned' || displayAs=='unattached',
					'text-clinking_gray':displayAs=='draft'
				}">

					<!-- duplicate -->
					<li >
						<a (click)="duplicatePost()">
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-files"><path d="M20 7h-3a2 2 0 0 1-2-2V2"/><path d="M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"/><path d="M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"/></svg><span class="text-black"  [title]="'generic.comingSoon' | translate">{{'posts.duplicate'|translate}}</span>
						</a>
					</li>

					<!-- update | continue -->
					<li>
						<a *ngIf="displayAs !== 'failed'" (click)="isAllInstagram() ? emitOpenModal('update') : displayAs == 'post' ? useAsNewPostTemplate('update') : useAsNewPostTemplate(displayAs)">
							<svg *ngIf="displayAs !== 'draft'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil">
								<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/>
								<path d="m15 5 4 4"/>
							</svg>
							<svg *ngIf="displayAs === 'draft'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-step-forward">
								<line x1="6" x2="6" y1="4" y2="20"/>
								<polygon points="10,4 20,12 10,20"/>
							</svg>
							<span class="text-black" >
								{{ displayAs === 'draft' ? ('posts.continueCreation' | translate) : ('generic.edit' | translate) }}
							</span>
						</a>
					</li>

					<!-- sync | continue -->
					<li>
						<a *ngIf="displayAs === 'failed'||displayAs=='post'" (click)="sync()">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-fading-arrow-up-icon lucide-circle-fading-arrow-up"><path d="M12 2a10 10 0 0 1 7.38 16.75"/><path d="m16 12-4-4-4 4"/><path d="M12 16V8"/><path d="M2.5 8.875a10 10 0 0 0-.5 3"/><path d="M2.83 16a10 10 0 0 0 2.43 3.4"/><path d="M4.636 5.235a10 10 0 0 1 .891-.857"/><path d="M8.644 21.42a10 10 0 0 0 7.631-.38"/></svg>

							<span class="text-black" [title]="'generic.comingSoon' | translate">
							{{('posts.syncWithplatforms' | translate) }}
							</span>
						</a>
					</li>
					<!-- delete | cancel -->
					<li *ngIf="displayAs !== 'failed'">
						<a (click)="emitOpenModal()" class="text-cliking_red">
							<svg  width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2">
								<path d="M3 6h18"/>
								<path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
								<path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
								<line x1="10" x2="10" y1="11" y2="17"/>
								<line x1="14" x2="14" y1="11" y2="17"/>
							</svg>
							<span class="text-black" [title]="'generic.comingSoon' | translate">
								{{ 'generic.delete' | translate }}
							</span>
						</a>
					</li>
					<!-- remove failed publications -->
					<!-- <li *ngIf="displayAs === 'failed'">
						<a (click)="emitOpenModal('cancel')" class="text-cliking_red">
							<svg  width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2">
								<path d="M3 6h18"/>
								<path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
								<path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
								<line x1="10" x2="10" y1="11" y2="17"/>
								<line x1="14" x2="14" y1="11" y2="17"/>
							</svg>
							<span class="text-black" [title]="'generic.comingSoon' | translate">
								{{ 'generic.cancelPublication' | translate }}
							</span>
						</a>
					</li> -->

				</ul>
			</div>
		</li>
	</ul>

</div>

